import React from 'react';
import { useLoadersTracingRef } from 'monitoring/use-loaders-tracing-ref';

import { FetchStatus, isFetchStatusPending } from '@neptune/shared/common-domain';
import { bemBlock } from '@neptune/shared/venus-ui';

import SmallSpin from './assets/spin.svg?react';

import './LoadingIndicator.less';

export type LoadingIndicatorSize = 'big' | 'medium' | 'small' | 'xsmall';

type LoadingIndicatorProps = {
  className?: string;
  centered?: boolean;
  isVisible?: boolean;
  fetchStatus?: FetchStatus;
  size?: LoadingIndicatorSize;
  customColor?: boolean;
};

const block = bemBlock('loading-indicator');

export const LoadingIndicator = ({
  className,
  isVisible,
  centered,
  fetchStatus,
  size = 'big',
  customColor = false,
}: LoadingIndicatorProps) => {
  const visible = (fetchStatus && isFetchStatusPending(fetchStatus)) || isVisible;

  const loaderRef = useLoadersTracingRef<HTMLDivElement>(!!visible);

  const cssClasses = block({
    extra: className,
    modifiers: {
      ...(size ? { [size]: true } : {}),
      visible: visible || undefined,
      centered: centered || undefined,
      'custom-color': customColor || undefined,
    },
  });

  return (
    <div
      ref={loaderRef}
      className={cssClasses}
      data-visible={visible}
      data-role="loading-indicator"
    >
      {(size === 'small' || size === 'xsmall') && <SmallSpin />}
    </div>
  );
};

export const FetchingIndicator = LoadingIndicator;

export default LoadingIndicator;
